import { render, staticRenderFns } from "./CenterLoading.vue?vue&type=template&id=791dc278&"
import script from "./CenterLoading.vue?vue&type=script&lang=js&"
export * from "./CenterLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports